import { apiClient } from '../index';

/**
 * [Crea un pago a proveedor
]
 * @return {[type]}          [description]
 */
function createPayment(data) {
  return apiClient.post('/v1/supplier-payments', data);
}

/**
 * [Crea un pago a proveedor
]
 * @return {[type]}          [description]
 */
function createSpendType (data) {
  return apiClient.post('/v1/supplier-payments/spendtype', data);
}

/**
 * [Encuentra los pagos a proveedores según los criterios de búsqueda]
 * Fecha de inicio (DD-MM-YYYY)
 * @return {[type]}          [description]
 */
 function search({ startDate, endDate, paymentTypeId, limit }) {
  return apiClient.get('/v1/supplier-payments/search', { 
    params: {
      startDate, endDate, paymentTypeId, limit
    } 
  });
}

/**
 * [Encuentra tipos de pagos]
 * Fecha de inicio (DD-MM-YYYY)
 * @return {[type]}          [description]
 */
 function paymentTypes() {
  return apiClient.get('/v1/supplier-payments/payment-types');
}

/**
 * [Actualiza un solón gasto]
 * @return {[type]}          [description]
 */
 function update(id, data) {
  return apiClient.put('/v1/supplier-payments/' + id, data);
}

/**
 * [Elimina un gasto]
 * @return {[type]}          [description]
 */
 function eliminar(id) {
  return apiClient.delete('/v1/supplier-payments/' + id );
}

/**
 * [obtiene los datos del reporte]
 * @return {[type]}          [description]
 */
function getDataRep(filter, fields) {
  const params =  { filter: filter, fields: fields }
  return apiClient.get('/v1/supplier-payments/dataRep', { params });
}

/**
 * [Elimina un tipo de gasto]
 * @return {[type]}          [description]
 */
 function delSpendType(id) {
  return apiClient.delete('/v1/supplier-payments/spendtype/' + id );
}

/**
 * [Actualiza un solón gasto]
 * @return {[type]}          [description]
 */
 function editSpendType(id, data) {
  return apiClient.put('/v1/supplier-payments/spendtype/' + id, data);
}

export default { createPayment, 
  createSpendType, 
  search, 
  paymentTypes, 
  update, 
  eliminar, 
  getDataRep,
  delSpendType,
  editSpendType
};